module.exports = __webpack_public_path__ + "static/media/logo-large-BN.20f577c1.png";